import type React from 'react'

/**
 * The inline styles of the Files table, shared by its file rows and by the rows that are not files
 * (the pinned section and the Shared virtual folder), so they all look like one tree.
 */

export const fileTableStyle: React.CSSProperties = {
  borderRadius: 'var(--ob-file-table-border-radius)',
  border: `1px solid var(--ob-file-table-border-color)`,
  overflow: 'hidden',
}

export const fileTableHeaderRowStyle: React.CSSProperties = {
  borderBottom: '2px solid var(--ob-file-table-border-color)',
  backgroundColor: 'var(--ob-gray-50, #f8f9fa)',
}

export const fileTableHeaderCellStyle: React.CSSProperties = {
  padding: 'var(--ob-file-table-cell-padding)',
  fontWeight: 'var(--ob-font-weight-bold, 600)',
  fontSize: 'var(--ob-file-table-font-size)',
  color: 'var(--ob-gray-600, #6c757d)',
  borderBottom: 'none',
}

export const fileTableCellStyle: React.CSSProperties = {
  padding: 'var(--ob-file-table-cell-padding)',
  borderBottom: '1px solid var(--ob-file-table-border-color)',
  verticalAlign: 'middle',
}

export const fileTableCellContentStyle: React.CSSProperties = {
  fontSize: 'var(--ob-file-table-font-size)',
  lineHeight: 'var(--ob-file-table-line-height)',
}

/** The class of a cell's content, with {@link fileTableCellContentStyle}. */
export const FILE_TABLE_CELL_CONTENT_CLASS = 'text-dark fw-normal text-hover-gray-700 mb-0'
